import React, { useState, useEffect } from "react";
import { Fab, Zoom, Tooltip } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

const WhatsAppButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const phoneNumber = "201202000867"; // رقم الواتساب بدون + أو مسافات
  const message = "مرحباً! أنا مهتم بمعرفة المزيد عن نظام ريستو كاش"; // رسالة افتراضية

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);

    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const handleWhatsAppClick = () => {
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, "_blank");
  };

  return (
    <Zoom in={isVisible}>
      <Tooltip title="تواصل معنا عبر واتساب" placement="left" arrow>
        <Fab
          onClick={handleWhatsAppClick}
          sx={{
            position: "fixed",
            bottom: { xs: 20, md: 30 },
            right: { xs: 20, md: 30 },
            background: "linear-gradient(135deg, #25D366 0%, #128C7E 100%)",
            color: "white",
            width: { xs: 56, md: 64 },
            height: { xs: 56, md: 64 },
            boxShadow: "0 6px 20px rgba(37, 211, 102, 0.4)",
            zIndex: 1000,
            transition: "all 0.3s ease",
            animation: "pulse 2s ease-in-out infinite",
            "@keyframes pulse": {
              "0%, 100%": {
                transform: "scale(1)",
                boxShadow: "0 6px 20px rgba(37, 211, 102, 0.4)",
              },
              "50%": {
                transform: "scale(1.05)",
                boxShadow: "0 8px 30px rgba(37, 211, 102, 0.6)",
              },
            },
            "&:hover": {
              background: "linear-gradient(135deg, #128C7E 0%, #075E54 100%)",
              transform: "scale(1.1)",
              boxShadow: "0 8px 30px rgba(37, 211, 102, 0.6)",
            },
            "&::before": {
              content: '""',
              position: "absolute",
              inset: -4,
              borderRadius: "50%",
              background: "linear-gradient(135deg, #25D366, #128C7E)",
              opacity: 0.3,
              animation: "ripple 2s ease-out infinite",
            },
            "@keyframes ripple": {
              "0%": {
                transform: "scale(1)",
                opacity: 0.3,
              },
              "100%": {
                transform: "scale(1.5)",
                opacity: 0,
              },
            },
          }}
        >
          <WhatsAppIcon sx={{ fontSize: { xs: 28, md: 32 } }} />
        </Fab>
      </Tooltip>
    </Zoom>
  );
};

export default WhatsAppButton;
